var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      on: {
        touchstart: _vm.touchAction,
        touchmove: _vm.touchAction,
        touchend: _vm.touchAction
      }
    },
    [
      _c("div", { staticClass: "heading d-block d-sm-none d-md-block" }, [
        _c(
          "div",
          { staticClass: "title" },
          [_c("identity", { staticClass: "identity" })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "score" },
          [
            _vm._v("\n      " + _vm._s(_vm.$t("score")) + "\n      "),
            _c("tween-number", { attrs: { number: _vm.score, duration: 200 } })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "best-score" },
          [
            _vm._v("\n      " + _vm._s(_vm.$t("best")) + "\n      "),
            _c("tween-number", {
              attrs: { number: _vm.bestScore, duration: 200 }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "order-action" }, [
          _c("div", {
            staticClass: "order-minus",
            class: { disabled: _vm.currentGameDim === 4 },
            attrs: { title: _vm.$t("decrease") },
            on: { click: _vm.orderMinus }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "order-text" }, [
            _vm._v(
              _vm._s(_vm.currentGameDim) + "×" + _vm._s(_vm.currentGameDim)
            )
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "order-add",
            class: { disabled: _vm.currentGameDim === 9 },
            attrs: { title: _vm.$t("increase") },
            on: { click: _vm.orderAdd }
          })
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "new-game-btn",
            attrs: { title: "new game" },
            on: { click: _vm.newGame }
          },
          [_vm._v("\n      ⟳\n    ")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row  no-gutters" }, [
        _c("div", { staticClass: "col-0 col-sm-0 col-md-3 col-lg-3 col-xl" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-8 col-md-6 col-lg-6 col-xl game" },
          [
            _vm.gameOver
              ? _c("div", { staticClass: "game-over" }, [
                  _vm._v("\n        " + _vm._s(_vm.$t("over"))),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    { staticClass: "restart", on: { click: _vm.newGame } },
                    [_vm._v(_vm._s(_vm.$t("again")))]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.rowCol, function(row) {
              return _c(
                "div",
                { staticClass: "row  no-gutters" },
                _vm._l(row, function(rc) {
                  return _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("number", {
                        ref: "number",
                        refInFor: true,
                        attrs: {
                          number: _vm.numbers[rc.row][rc.col],
                          "view-width": _vm.viewWidth,
                          action: _vm.actions[rc.row][rc.col],
                          duration: _vm.duration
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            }),
            _vm._v(" "),
            _c("rate-feedback", {
              staticClass: "d-block d-sm-none d-md-block",
              attrs: { id: "rate-feedback", dialogTag: "normal" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-block d-sm-none d-md-block challenge-mode-navigate"
              },
              [
                _c(
                  "div",
                  {
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                      trigger: "manual",
                      title: _vm.$t("mode")
                    },
                    on: {
                      mouseover: _vm.challengeModeNavMouseOver,
                      mouseout: _vm.challengeModeNavMouseOut,
                      click: _vm.challengeModeNavMouseClick
                    }
                  },
                  [_vm._v("\n          ➨\n        ")]
                ),
                _vm._v(" "),
                _c("radio-toggle", {
                  staticClass: "radio-toggle",
                  model: {
                    value: _vm.radioStat,
                    callback: function($$v) {
                      _vm.radioStat = $$v
                    },
                    expression: "radioStat"
                  }
                })
              ],
              1
            )
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-0 col-sm-4 col-md-3 col-lg-3 col-xl" },
          [
            _c(
              "div",
              { staticClass: "heading-sm d-none d-sm-block d-md-none" },
              [
                _c(
                  "div",
                  { staticClass: "title-sm" },
                  [_c("identity", { staticClass: "identity-sm" })],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "score-area" }, [
                  _c(
                    "div",
                    { staticClass: "score-sm" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("score")) +
                          "\n            "
                      ),
                      _c("tween-number", {
                        attrs: { number: _vm.score, duration: 200 }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "best-score-sm" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("best")) +
                          "\n            "
                      ),
                      _c("tween-number", {
                        attrs: { number: _vm.bestScore, duration: 200 }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "order-action-sm" }, [
                  _c("div", {
                    staticClass: "order-minus-sm",
                    class: { disabled: _vm.currentGameDim === 4 },
                    attrs: { title: _vm.$t("decrease") },
                    on: { click: _vm.orderMinus }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "order-text-sm" }, [
                    _vm._v(
                      _vm._s(_vm.currentGameDim) +
                        "×" +
                        _vm._s(_vm.currentGameDim)
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "order-add-sm",
                    class: { disabled: _vm.currentGameDim === 9 },
                    attrs: { title: _vm.$t("increase") },
                    on: { click: _vm.orderAdd }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "new-game-btn-sm-area" }, [
                  _c(
                    "a",
                    {
                      staticClass: "new-game-btn-sm",
                      attrs: { title: "new game" },
                      on: { click: _vm.newGame }
                    },
                    [_vm._v("\n            ⟳\n          ")]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "a-row",
              {
                staticClass: "rate-sm d-none d-sm-block d-md-none",
                attrs: { gutter: 8 }
              },
              [
                _c(
                  "a-col",
                  { attrs: { span: 8 } },
                  [
                    _c("a-statistic", {
                      staticClass: "score-rate-first",
                      attrs: {
                        title: _vm.scoreFirstUserName,
                        value: _vm.scoreFirstScore,
                        valueStyle:
                          "font-size:16px;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "suffix",
                          fn: function() {
                            return [
                              _c("icon-font", {
                                attrs: { type: "icon-guanjun" }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 8 } },
                  [
                    _c("a-statistic", {
                      staticClass: "score-rate-second",
                      attrs: {
                        title: _vm.scoreSecondUserName,
                        value: _vm.scoreSecondScore,
                        valueStyle:
                          "font-size:14px;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "suffix",
                          fn: function() {
                            return [
                              _c("icon-font", { attrs: { type: "icon-yajun" } })
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-col",
                  { attrs: { span: 8 } },
                  [
                    _c("a-statistic", {
                      staticClass: "score-rate-third",
                      attrs: {
                        title: _vm.scoreThirdUserName,
                        value: _vm.scoreThirdScore,
                        valueStyle:
                          "font-size:12px;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "suffix",
                          fn: function() {
                            return [
                              _c("icon-font", { attrs: { type: "icon-jijun" } })
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tip-sm d-none d-sm-block d-md-none" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("left")) +
                  " ← ↑ → ↓ " +
                  _vm._s(_vm.$t("right")) +
                  "!\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-none d-sm-block d-md-none",
                attrs: { id: "last-line-sm" }
              },
              [
                _c(
                  "div",
                  { attrs: { id: "last-line-container-sm" } },
                  [
                    _c("rate-feedback", {
                      attrs: { id: "rate-feedback-sm", dialogTag: "small" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "challenge-mode-navigate-sm" },
                      [
                        _c(
                          "div",
                          {
                            attrs: {
                              "data-toggle": "tooltip",
                              "data-placement": "bottom",
                              trigger: "manual",
                              title: _vm.$t("mode")
                            },
                            on: {
                              mouseover: _vm.challengeModeNavMouseOverSM,
                              mouseout: _vm.challengeModeNavMouseOutSM,
                              click: _vm.challengeModeNavMouseClickSM
                            }
                          },
                          [_vm._v("\n              ➨\n            ")]
                        ),
                        _vm._v(" "),
                        _c("radio-toggle", {
                          staticClass: "radio-toggle-sm",
                          model: {
                            value: _vm.radioStat,
                            callback: function($$v) {
                              _vm.radioStat = $$v
                            },
                            expression: "radioStat"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tip d-block d-sm-none d-md-block" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("left")) +
            " ← ↑ → ↓ " +
            _vm._s(_vm.$t("right")) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "a-row",
        {
          staticClass: "rate d-block d-sm-none d-md-block",
          attrs: { gutter: 8 }
        },
        [
          _c(
            "a-col",
            { attrs: { span: 8 } },
            [
              _c("a-statistic", {
                staticClass: "score-rate-first",
                attrs: {
                  title: _vm.scoreFirstUserName,
                  value: _vm.scoreFirstScore,
                  valueStyle:
                    "font-size:16px;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                },
                scopedSlots: _vm._u([
                  {
                    key: "suffix",
                    fn: function() {
                      return [
                        _c("icon-font", { attrs: { type: "icon-guanjun" } })
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-col",
            { attrs: { span: 8 } },
            [
              _c("a-statistic", {
                staticClass: "score-rate-second",
                attrs: {
                  title: _vm.scoreSecondUserName,
                  value: _vm.scoreSecondScore,
                  valueStyle:
                    "font-size:14px;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                },
                scopedSlots: _vm._u([
                  {
                    key: "suffix",
                    fn: function() {
                      return [
                        _c("icon-font", { attrs: { type: "icon-yajun" } })
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-col",
            { attrs: { span: 8 } },
            [
              _c("a-statistic", {
                staticClass: "score-rate-third",
                attrs: {
                  title: _vm.scoreThirdUserName,
                  value: _vm.scoreThirdScore,
                  valueStyle:
                    "font-size:12px;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
                },
                scopedSlots: _vm._u([
                  {
                    key: "suffix",
                    fn: function() {
                      return [
                        _c("icon-font", { attrs: { type: "icon-jijun" } })
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }